module.exports = __webpack_public_path__ + "img/bg-popup-2.e2f87c13.jpeg";